exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-prismic-blog-post-uid-js": () => import("./../../../src/pages/{prismicBlogPost.uid}.js" /* webpackChunkName: "component---src-pages-prismic-blog-post-uid-js" */)
}

